import { LanguageType } from "../../types";
import isLanguageType from "./isLanguageType";

export default function getLanguageFromUrl(): LanguageType | null {
  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.get("lang")?.trim();

  if (!lang) return null;

  const normalizedLang = lang.toLowerCase();

  return isLanguageType(normalizedLang) ? normalizedLang : null;
}
